import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './AIGCMessage.module.less';
import { aigcShowMessage } from '../../../../actions/aigc';
import messageImg from '../../../../static/aigc/ai_tishi.png';

const selectAIGCMessage = createSelector(
  state => state.aigc,
  aigc => aigc.aigcMessage
);

export default memo(() => {
  const dispatch = useDispatch();
  const aiMessage = useSelector(selectAIGCMessage);

  useEffect(() => {
    let timer1 = setTimeout(() => {
      dispatch(aigcShowMessage({ isShow: false }));
    }, 3000);
    return () => {
      clearInterval(timer1);
    };
  }, []);

  return (
    <div className={styles.aigc_message}>
      <img src={messageImg} />
      <div>{aiMessage?.content}</div>
    </div>
  );
});
